<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>
    <div class="category-view" v-if="category && !loadingMood">
        <div class="container-size-fixer main-container">
            <div id="main-text-content">
                <div id="direction">
                    <ul v-if="!inheritance">
                        <li class="parent-gray">خانه</li>
                        <li><img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt=""></li>
                        <li>{{category.name}}</li>
                    </ul>
                    <ul v-else>
                        <li v-for="(parent , index) in inheritance" :key="parent" class="inheritance">
                            <span :class="index === inheritance.length+1 ? '' : 'parent-gray'">
                               {{parent.name}}
                            </span>

                            <img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt="">

                            <span v-if="inheritance.length === index+1">
                                {{category.name}}
                            </span>
                        </li>
                    </ul>
                </div>
                <div id="title">
                    {{category.name}}
                </div>
                <div id="main-category-content" v-html="category.long_explain"></div>
            </div>
            <div id="footer-content">
                    <div class="row">
                        <div class="small-div col-lg-6 col-md-6 col-sm-12">
                            <div  v-on:click="$router.push('/faq')">
                                <span>مشاهده سوالات متداول</span>
                                <img width="80" height="80" src="../assets/new/New/Icon/qa.png" alt="">
                            </div>
                        </div>
                        <div class="small-div col-lg-6 col-md-6 col-sm-12">
                            <div  v-on:click="$router.push('/user-signup')">
                                <span>فرم ارزشیابی رایگان</span>
                                <img width="80" height="80" src="../assets/new/New/Icon/clipboard.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <div class="space"></div>
        <div class="all-related-posts-btn">

            <!--<div @click.prevent="$router.push('/related-articles/'+category.slug)">-->
                   <!--مشاهده تمام مقالات مرتبط-->
            <!--</div>-->

            <SubCategory :subcategory = "category" :inheritance="''" :parent="true"/>

        </div>


        <div class="category-content-box" v-if="category.active_childes">
            <div v-for="subcategory in category.active_childes" :key="subcategory">
                <div class="space"></div>
                <div class="category-content">
                    <SubCategory :subcategory = "subcategory" :inheritance="''"/>
                </div>
            </div>
        </div>
    </div>
    <div class="category-view" v-if="loadingMood">
       <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>
</template>

<script>
    import SubCategory from '../components/SubCategory'
    import Alert from "../components/Alert"
    import axios from "axios"
    export default {
        name: "CategoryView",
        data(){
            return{
                alertContent: null,
                loadingMood: false,
                category:null,
                slug:this.$route.params.slug,
                inheritance:null,
            }
        },
        components:{
            SubCategory,
            Alert
        },
        methods: {
            async getCategoryDetails(){
                try {
                    this.loadingMood=true;
                    let response = await axios.get('api/getCategoryDetails/'+this.slug);
                    this.loadingMood=false;
                    this.category = response.data.results;
                    this.inheritance = response.data.inheritance;
                } catch (error) {
                    console.log(error)
                }
            },
        },

        created() {
            this.getCategoryDetails();
        },
        watch: {
            $route(to, from) {
                if (to !== from) {
                    this.slug = this.$route.params.slug;
                    this.getCategoryDetails();
                }
            },
        }
    }
</script>

<style lang="scss"  scoped>
    .all-related-posts-btn{
        width: 100%;
        padding: 50px 0;
        cursor: pointer;
        //&:hover{text-decoration: underline;}
    }
    .empty{
    background-color: rgba(232, 232, 232, 0.5);
    }
    .category-content-box{
        overflow-x: hidden;
    }
    .category-content{
        padding:0px!important; ;
    }
    #main-image-content{
        max-width: 970px;
        width: 100%;
        height: 450px;
        /*background-color: #4285f4;*/
        background-size: cover;
        background-repeat: no-repeat;
        margin: auto;
    }
    #main-text-content, #footer-content{
        height: auto;
        /*max-width: 970px;*/
        width: 100%;
        margin: auto;
    }
    #footer-content{
        overflow: hidden;
        .row{
            margin-top: 50px;
        }
    }

    .category-view{
        background-color: white;
        .container-size-fixer{
            margin: auto;
            background-color: #4285f4;
        }
    }




    #main-category-content{
        overflow: hidden;
        padding-top: 50px;
        text-align: right;
    }

    #direction>ul{
        padding: 0;
        text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
    }
    .inheritance{
        height: auto;
        width: 100%;
        text-align: right;
        display: flex;
        align-items: center;
        img{
            margin: 0 5px;
        }
        color: black!important;
    }
    .parent-gray{
        color: lightgrey;
    }


    .small-div{
        min-height: 140px;
        div{
            cursor: pointer;
            padding: 10px;
            margin-top: 15px;
            width: 100%;
            height: 140px;
            background-color: #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                margin: 20px;
            }
            image{

            }
        }
    }
    .main-container{
        max-width: 1120px;
        width: 100%;
        background-color: white!important;
        margin: auto;
        padding: 50px 15px;






        #title{
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
</style>